import en from './en'
import pl from './pl'

const locales: { [key: string]: { quasar: Json, messages: Json, numberFormats: Json, dateTimeFormats: Json } } = {
  en,
  pl
}

export default locales
